import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import ProductForm from '../components/ProductForm';
import { getProductoById } from '../services/productos';
import { Producto } from '../types';

const ProductFormPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const location = useLocation();
    const [product, setProduct] = useState<Producto | undefined>(undefined);
    const [loading, setLoading] = useState<boolean>(!!id);

    useEffect(() => {
        const fetchProduct = async () => {
            // Check if product is passed via state
            const stateProduct = location.state?.product as Producto;
            if (stateProduct) {
                setProduct(stateProduct);
                setLoading(false);
                return;
            }

            if (!id) return;
            try {
                const data = await getProductoById(parseInt(id));
                setProduct(data);
            } catch (err) {
                console.error("Error fetching product for edit", err);
                // Handle error
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchProduct();
        }
    }, [id, location.state]);

    const handleClose = () => {
        navigate('/productos');
    };

    const handleSuccess = (msg: string) => {
        alert(msg); // Or toast
        navigate('/productos');
    };

    if (loading) return <div>Cargando...</div>;

    return (
        <div className="page" style={{ padding: '20px' }}>
            <ProductForm
                onClose={handleClose}
                onSuccess={handleSuccess}
                {...(product ? { productData: product } : {})}
            />
        </div>
    );
};

export default ProductFormPage;
